import { useRef, useState } from "react";
import { IPermissionProps } from "../../../models/Login";
import { Form } from "./Form";
import { Toast } from "primereact/toast";
import { Table } from "./Table";
import { RFPBidTeamMemberForm } from "./RFPBidTeamMemberForm";
import { MoveBidTeamMembersForm } from "./MoveBidTeamMembersForm";
export interface IBidTeamMast {
  branch?: string;
  company?: string;
  team_ID?: number;
  team_Manager?: string;
  team_Name?: string;
  category?:string;
}
export interface IBidTeamData {
  branch?: string;
  branch_ID?: number;
  company?: string;
  company_ID?: number;
  team_ID?: number;
  team_Manager?: string;
  team_Manager_ID?: number;
  team_Name?: string;
  tender_Client_Category?:number
}

export interface IRFPBidTeamManagement {
  Team_ID?: number;
  Team_Name?: string;
  Tender_Client_Category?:number;
  Status?: boolean;
  User_Added_by ?: number;
  CreatedOn ?: Date;
  TeamManagerid?: number;
  Company_Name?: number;
  Branch_Name?: number;
}

export interface IModel {
  open: boolean;
  singleData: IRFPBidTeamManagement;
  teamNameList: IBidTeamMast[];
}

export interface IModel2 {
  open: boolean;
  singleData: IBidTeamData;
}

export interface IModel3 {
  open: boolean;
  singleData: IBidTeamData[];
  inTeam: IBidTeamData;
}

export const EmptyBidTeam: IRFPBidTeamManagement = {
  Team_Name: "",
  Company_Name: 0,
  Branch_Name: 0,
  TeamManagerid: 0,
};

export const BidTeamData: IBidTeamData = {
  branch: "",
  branch_ID: 0,
  company: "",
  company_ID: 0,
  team_ID: 0,
  team_Manager: "",
  team_Manager_ID: 0,
  team_Name: "",
  tender_Client_Category:0
};

export const RPFBidTeamManagement = (permissions: IPermissionProps) => {
  const [modal, setModal] = useState({ singleData: EmptyBidTeam, open: false, teamNameList: [] } as IModel);
  const [modal2, setModal2] = useState({ singleData: BidTeamData, open: false } as IModel2);
  const [modal3, setModal3] = useState({ singleData: [], open: false, inTeam: {} } as IModel3);
  const [reload, setReload] = useState(false);
  const [reload2, setReload2] = useState(false);
  const [reload3, setReload3] = useState(false);
  const toast = useRef<any>(null);

  const hideDialog = () => {
    setModal({ singleData: EmptyBidTeam, open: false, teamNameList: [] });
  };
  const hideDialog2 = () => {
    setModal2({ singleData: BidTeamData, open: false });
  };
  const hideDialog3 = () => {
    setModal3({ singleData: [], open: false, inTeam: BidTeamData });
  };

  return (
    <>
      <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} teamNameList={modal.teamNameList}></Form>
      <RFPBidTeamMemberForm singleData={modal2.singleData} open={modal2.open} hideDialog={hideDialog2} toast={toast} reload={reload2} setReload={setReload2} setModal={setModal} setModal3={setModal3} />
      <MoveBidTeamMembersForm singleData={modal3.singleData} open={modal3.open} hideDialog={hideDialog3} toast={toast} reload={reload3} setReload={setReload3} inTeam={modal3.inTeam} setModal={setModal2} />
      <Table permissions={permissions} setModal={setModal} setModal2={setModal2} toast={toast} reload={reload} setReload={setReload}></Table>
      <Toast ref={toast} />
    </>
  );
};
